import { useState } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { toast } from "react-toastify";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import useMediaQuery from "@mui/material/useMediaQuery";
import { checkRefferlCodeForUseApi } from "../../../../../services/marketingApi";
import { setReferralCodeApi } from "../../../../../services/authApi";
import {
  customToastify,
  checkErrorMessage,
  checkResponseData,
} from "../../../utils/utilsFunctions";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    padding: 4,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: 10,
    // margin:1
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function SetRegisterCode(props) {
  const { authUserinfo } = props;
  const detectSize600px = useMediaQuery("(min-width:600px)");
  const [marketingCode, setMarketingCode] = useState("");
  const [message, setMessage] = useState({
    status: false,
    marketingCode: "",
    message: "",
  });
  const handleClickCheck = async () => {
    const toastMsg = toast.loading("لطفا صبر کنید...")
    try {
      if (marketingCode.length < 1) {
        toast.update(toastMsg, { render: "لطفا ابتدا کد را وارد کنید", type: "error", isLoading: false, autoClose: 3000 });
        setMessage({
          status: false,
          marketingCode: "",
          message: "لطفا ابتدا کد را وارد کنید",
        });
        return false;
      }
      setMessage({
        status: false,
        marketingCode: "",
        message: "لطفا صبر کنید",
      });
      const response = await checkRefferlCodeForUseApi({ marketingCode, productId: "forRegister" })
      const checkResponse = checkResponseData(response);
      if (checkResponse["message"]) {
        toast.update(toastMsg, { render: checkResponse["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
        setMessage({
          status: true,
          marketingCode,
          message: checkResponse["message"],
        });
      } else {
        toast.update(toastMsg, { render: checkResponse["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
        console.log(response)
      };
    } catch (error) {
      const checkError = checkErrorMessage(error);
      let errMsg = checkError["titles"] || checkError["message"]
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
      if (checkError["titles"]) {
        setMessage({
          status: false,
          marketingCode: "",
          message: checkError["titles"],
        });
      } else if (checkError["message"]) {
        setMessage({
          status: false,
          marketingCode: "",
          message: checkError["message"],
        });
      } else console.error(error);
    }
  };
  const handleClickSubmit = async () => {
    const toastMsg = toast.loading("لطفا صبر کنید...")

    try {
      if (!message.status) {
        toast.update(toastMsg, { render: "لطفا ابتدا روی بررسی کلیک کنید", type: "error", isLoading: false, autoClose: 3000 });
        return false;
      }
      const response = await setReferralCodeApi({ registerCode: message["marketingCode"] })
      const checkResponse = checkResponseData(response);
      if (checkResponse["message"]) {
        toast.update(toastMsg, { render: checkResponse["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
        setMessage({
          status: true,
          marketingCode,
          message: checkResponse["message"],
        });
      } else {
        toast.update(toastMsg, { render: checkResponse["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
        console.log(response)
      };
    } catch (error) {
      const checkError = checkErrorMessage(error);
      let errMsg = checkError["titles"] || checkError["message"]
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
      if (checkError["titles"]) {
        setMessage({
          status: false,
          marketingCode: "",
          message: checkError["titles"],
        });
      } else console.error(error);
    }
  };

  return (
    <Box>
      <TableContainer component={Paper}>
        <Table aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell sx={{ width: detectSize600px ? "25%" : "50%" }}>
                کد معرف ثبت نام
              </StyledTableCell>
              <StyledTableCell sx={{ width: detectSize600px ? "75%" : "50%" }}>
                {" "}
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <StyledTableRow>
              <StyledTableCell component="th" scope="row">
                {"کد معرف ثبت نام"}
              </StyledTableCell>
              {authUserinfo["registerCode"] == "llmmt-Loading" ||
                authUserinfo["registerCode"] == "llmmt-errorLoading" ||
                !authUserinfo["registerCode"] ? (
                <StyledTableCell align="left">
                  <TextField
                    value={marketingCode}
                    size="small"
                    name="registerCode"
                    label="کد معرف ثبت نام"
                    placeholder="کد معرف ثبت نام"
                    type="text"
                    onChange={(e) => {
                      setMarketingCode(e.target.value);
                    }}
                  />
                  <Typography>{message["message"]}</Typography>
                  <Button
                    onClick={() => {
                      handleClickCheck();
                    }}
                    variant="contained"
                    sx={{ m: 0.2 }}
                    color="info"
                  >
                    بررسی
                  </Button>
                </StyledTableCell>
              ) : (
                <StyledTableCell align="left">
                  <Typography>{authUserinfo["registerCode"]}</Typography>
                </StyledTableCell>
              )}
            </StyledTableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <Button
        onClick={() => {
          handleClickSubmit();
        }}
        type="submit"
        variant="contained"
        sx={{ m: 2 }}
        color="success"
      >
        ذخیره
      </Button>
    </Box>
  );
}
